<template>
  <div class="vacation-month-select">
    <div class="month-type">
      <button
        @click="setMonthType(0)"
        :class="{ active: monthType === 0 }"
        class="date-range"
      >
        {{ $t("תאריכים ספציפים") }}
      </button>
      <button
        @click="setMonthType(1)"
        :class="{ active: monthType === 1 }"
        class="all-month"
      >
        {{ $t("ספונטנים וגמישים") }}
      </button>
    </div>
    <template v-if="monthType === 0">
      <HotelDatePicker
        :i18n="ptBr"
        :hoveringTooltip="false"
        :show-year="true"
        @check-in-changed="setStartDate"
        @check-out-changed="setEndDate"
      >
        ></HotelDatePicker
      >

      <div class="mobile-date-picker">
        <v-date-picker
          locale="he"
          title-position="left"
          mode="range"
          is-inline
          v-model="mobileSelectedDate"
        ></v-date-picker>
      </div>
    </template>
    <vacation-type-swiper
      v-show="monthType === 1"
      class="vacation-month-slider"
    >
      <template v-if="months">
        <div
          class="swiper-slide"
          :data-month="month.month"
          v-for="month in months"
        >
          <div class="slide-inner-wrap">
            <div
              @click="nextStep()"
              :style="{ 'background-image': 'url(' + month.thumbnail + ')' }"
              class="slide-inner"
            >
              <div class="slide-fade"></div>
              <div class="slide-inside">
                <div class="date-title">{{ $t("חודש") }}</div>
                <div class="title">{{ month.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </vacation-type-swiper>
    <next-step-btn></next-step-btn>
  </div>
</template>

<script>
import Vue from "vue";

import VacationTypeSwiper from "./VacationTypeSwiper.vue";
import VacationPlanSlider from "../../components/VacationPlanSlider";
import NextStepBtn from "./NextStepBtn.vue";
import HotelDatePicker from "vue-hotel-datepicker";

export default {
  components: {
    VacationTypeSwiper,
    NextStepBtn,
    HotelDatePicker,
  },
  props: ["months"],
  data() {
    return {
      siteData: window.siteData,
      monthType: 0,
      monthsSwiper: null,
      mobileSelectedDate: null,
      rangeDates: {
        start: null,
        end: null,
      },
      ptBr: {
        night: "Night",
        nights: "Nights",
        "day-names": ["S", "M", "T", "W", "T", "F", "S"],
        "check-in": "Check in",
        "check-out": "Check out",
        "month-names": [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
      },
    };
  },
  watch: {
    mobileSelectedDate(newValue) {
      const dateObj = new Date(newValue.start);
      let month = this.padDigits(dateObj.getMonth() + 1, 2);
      let dateDay = this.padDigits(dateObj.getDate(), 2);
      this.rangeDates.start = `${dateObj.getFullYear()}-${month}-${dateDay}`;

      if (!newValue.start) {
        window.eventBus.$emit("selectRangeMonth", null);
        return;
      }

      const dateObjEnd = new Date(newValue.end);
      let monthEnd = this.padDigits(dateObjEnd.getMonth() + 1, 2);
      let dateDayEnd = this.padDigits(dateObjEnd.getDate(), 2);

      this.rangeDates.end = `${dateObjEnd.getFullYear()}-${monthEnd}-${dateDayEnd}`;

      window.eventBus.$emit("selectRangeMonth", this.rangeDates);
      window.eventBus.$emit("nextStep");
    },
  },
  methods: {
    nextStep() {
      window.eventBus.$emit("nextStep");
    },
    padDigits(number, digits) {
      return (
        Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
      );
    },
    setStartDate(date) {
      const dateObj = new Date(date);
      let month = this.padDigits(dateObj.getMonth() + 1, 2);
      let dateDay = this.padDigits(dateObj.getDate(), 2);

      this.rangeDates.start = `${dateObj.getFullYear()}-${month}-${dateDay}`;
    },
    setEndDate(date) {
      if (!date) {
        window.eventBus.$emit("selectRangeMonth", null);
        return;
      }

      const dateObj = new Date(date);
      let month = this.padDigits(dateObj.getMonth() + 1, 2);
      let dateDay = this.padDigits(dateObj.getDate(), 2);

      this.rangeDates.end = `${dateObj.getFullYear()}-${month}-${dateDay}`;

      window.eventBus.$emit("selectRangeMonth", this.rangeDates);
    },
    setMonthType(month) {
      this.monthType = month;
      window.eventBus.$emit("setMonthType", month);

      if (month === 1) {
        Vue.nextTick(() => {
          window.eventBus.$emit("selectWholeMonth", this.months[0].month);
          window.eventBus.$emit("selectRangeMonth", null);
          this.monthsSwiper.swiper.update();
        });
      } else {
        window.eventBus.$emit("selectWholeMonth", -1);
        window.eventBus.$emit("selectRangeMonth", null);
        this.monthsSwiper.swiper.slideTo(0);
      }
    },
  },
  mounted() {
    this.monthsSwiper = new VacationPlanSlider(".vacation-month-slider");

    Vue.nextTick(() => {
      this.monthsSwiper.swiper.on("slideChange", () => {
        const wholeMonth = $(
          this.monthsSwiper.swiper.slides[this.monthsSwiper.swiper.activeIndex]
        ).data("month");
        if (this.monthType === 1) {
          window.eventBus.$emit("selectWholeMonth", wholeMonth);
        }
      });
    });
  },
};
</script>

<style lang="scss">
.mobile-date-picker {
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  display: none;

  .vc-container {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    display: flex;
  }
}

.vc-grid-container {
  direction: ltr;
}

.vc-arrows-container.title-left {
  justify-content: flex-end;
  flex-direction: row-reverse;
}

.vc-header .vc-title {
  font-size: 14px;
  letter-spacing: 0.52px;
  color: #6b7897;
}

.vc-weekday {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.21 !important;
  color: rgba(52, 72, 94, 0.54) !important;
  margin-bottom: 15px;
  margin-top: 15px;
}

.vc-arrows-container {
  svg {
    width: 19.2px;
    height: 19.2px;
    border-radius: 9.9px;
    background-color: #f7f8fc;
  }
}

.vc-rounded-full.vc-text-white {
  background-color: #0f1836 !important;
}
.vc-rounded-full.vc-font-bold.vc-text-white {
  background-color: #0f1836 !important;
  color: #fff;
}

//vc-day-content vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full  vc-font-bold vc-text-blue-900
//vc-day-content vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full  vc-font-bold vc-text-white
/*.vc-rounded-full.vc-font-bold.vc-text-blue-900{*/
/*background-color: #0f1836 !important;*/
/*color: #fff;*/
/*}*/
.vc-rounded-full.vc-text-blue-900 {
  background-color: transparent !important;
}

.datepicker__wrapper {
  margin-bottom: 78px;
  background-image: none !important;
  height: 100% !important;
  background: transparent !important;

  @media screen and (max-width: 767px) {
    display: none !important;
  }

  .datepicker__clear-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      stroke: #000;
      width: 21px;
    }
  }

  .datepicker__week-row {
    border-bottom: none !important;
  }

  .datepicker {
    position: relative !important;
    max-height: 100% !important;
    float: none;
    top: auto;
    left: auto;
    background-color: transparent !important;

    .datepicker__inner {
      width: 100%;
      float: none;

      .datepicker__month-button {
        background: transparent
          url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='34' viewBox='0 0 20 34'%3E%3Cpath fill='none' fill-rule='evenodd' stroke='%23000' stroke-width='4.166' d='M2 2.429L17 17 2 31.571'/%3E%3C/svg%3E%0A");
        background-repeat: no-repeat;
        width: 40px;
        height: 40px;
        background-position: center;
      }

      .datepicker__month-button:focus {
        outline: none;
      }

      .datepicker__month-button--prev {
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        left: auto;
        position: absolute;
      }

      .datepicker__month-button--next {
        top: 50%;
        transform: translateY(-50%) rotateY(180deg);
        left: 0;
        right: auto;
        position: absolute;
      }

      .datepicker__months {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-direction: row;

        .datepicker__month {
          float: none !important;
          width: auto !important;
          padding: 25px;
          border-radius: 8.5px;
          box-shadow: 0 4px 34px 0 #ededed;
          background-color: #ffffff;
          flex: 0 420px !important;
          margin: 0 15px;

          .datepicker__month-day--selected {
            background-color: #eff7ff !important;
          }

          .datepicker__month-day--first-day-selected,
          .datepicker__month-day--last-day-selected {
            background-color: #0f1836;
            opacity: 1;
            border-radius: 50%;
          }

          .datepicker__month-day {
            font-size: 20.6px;
            color: #7c86a2 !important;
            padding-top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px !important;
            border: none !important;

            &:hover {
              box-shadow: none;
              background-color: #eff7ff !important;
            }

            &:focus {
              outline: none;
            }
          }

          .datepicker__month-day--disabled {
            color: #e1e4e7 !important;
          }

          .datepicker__week-name {
            font-size: 22.2px;
            font-weight: 500;
            line-height: 1.21;
            color: rgba(52, 72, 94, 0.54);
          }

          .datepicker__month-name {
            margin: 0;
            font-size: 21.3px !important;
            letter-spacing: 0.8px !important;
            color: #6b7897 !important;
            text-align: left;
            font-weight: normal;
            padding: 0 18px;
            padding-bottom: 30px;
          }
        }

        &:before {
          display: none;
        }
      }
    }
  }
}

.datepicker__dummy-wrapper {
  display: none !important;
}
</style>
